export interface IReturnTextConfig {
  email_address: string
  verification_code: string
  bottom_description: string
  return_policy_link: IReturnPolicy
  confirm_button_name: string
  email_address_error_tips: string
  verification_code_error_tips: string
  order_email_address: string
  order_order_number: string
  order_bottom_description: string
  order_confirm_button_name: string
  order_number_error_tips: string
  order_lookup_method: LoginType
  return_policy_link_text_name: string
  hide_merchant_contact_information: number
  email_or_phone_error_tips: string
}

export enum LoginType {
  Order_With_Email = 1,
  Email_With_Code = 2,
}

export interface IReturnPolicy {
  type: string
  value: string
  content: string
}

export type RenderType = "brand_logo" | "text"

export interface IPortalTopContent {
  type: RenderType
  value: string
  url: string
}

export interface IReturnStyleConfig {
  background_image: string
  return_page_primary_color: string
  primary_btn_text_color: string
  login_pop_up: {
    corner_radius: string | number
    opacity: number
  }
  font_family: {
    font: string
    isDefault: boolean
    link: string
  }
  portal_top_content: IPortalTopContent
  portal_top_logo_width: number
  ex_product_page: {
    logo: string
    title: string
  }
  custom_css: string
}

export enum LanguageModule {
  LOGIN_PAGE = 0,
  ORDER_LIST_AND_DETAILS_PAGE = 1,
  RETURN_ITEM_SELECTION_PAGE = 2,
  RETURN_SOLUTION_SELECTION_PAGE = 3,
  RETURN_METHOD_SELECTION_PAGE = 4,
  CHECK_PAGE = 5,
  RETURN_STATUS_PAGE = 6,
}

export interface OriginData {
  check_page: CheckPage
  login_page: LoginPage
  order_list_details_page: OrderListDetailsPage
  return_item_selection_page: ReturnItemSelectionPage
  return_method_selection_page: ReturnMethodSelectionPage
  return_solution_selection_page: ReturnSolutionSelectionPage
  return_status_page: ReturnStatusPage
  [property: string]: any
}

export interface CheckPage {
  discount: string
  refund: string
  return_fee: string
  shipping_fee: string
  subtotal: string
  tax: string
  title: string
  total_refund: string
  [property: string]: any
}

export interface LoginPage {
  bottom_description: string
  confirm_button_name: string
  email_address: string
  error_tips_1: string
  error_tips_2: string
  error_tips_3: string
  order_bottom_description: string
  order_confirm_button_name: string
  order_email_address: string
  order_number: string
  policy_popup_name: string
  policy_text: string
  return_center: string
  verification_code: string
  [property: string]: any
}

export interface OrderListDetailsPage {
  create_return_button: string
  items: string
  log_out_button: string
  missed_the_return_window: string
  non_returnable_items: string
  non_returnable_reason: string
  order_has_been_refunded_at_shopify: string
  order_number: string
  other: string
  page_title: string
  request_return: string
  return_app_processed_item: string
  search_order_button: string
  view_button: string
  view_request_progress: string
  [property: string]: any
}

export interface ReturnItemSelectionPage {
  cancel: string
  confirm: string
  edit: string
  next: string
  one_item_prompt: string
  optional: string
  please_select: string
  popup_title: string
  prompt: string
  provide_proof: string
  required: string
  return_description: string
  return_quantity: string
  return_reason: string
  step_1: string
  step_2: string
  step_3: string
  step_4: string
  title: string
  [property: string]: any
}

export interface ReturnMethodSelectionPage {
  List: ReturnMethodSelectionPageList[]
  title: string
  [property: string]: any
}

export interface ReturnMethodSelectionPageList {
  CustomizeDescription: string
  CustomizeInstructions: string
  CustomizeName: string
  id: number
  name: string
  rules: Rules
  status: number
  [property: string]: any
}

export interface Rules {
  rule: null
  type: number
  [property: string]: any
}

export interface ReturnSolutionSelectionPage {
  List: ReturnSolutionSelectionPageList[]
  replace_title: string
  replacement: string
  select_replacement: string
  title: string
  [property: string]: any
}

export interface ReturnSolutionSelectionPageList {
  description: string
  id: number
  name: string
  sort: number
  status: number
  [property: string]: any
}

export interface ReturnStatusPage {
  actual_refund: string
  add: string
  add_tracking: string
  approved_status: string
  complete_return_status: string
  create_success_status: string
  discount_code: string
  download_return_label: string
  enter_shipment_details: string
  exchange_order: string
  exchange_order_created: string
  gift_card_code: string
  merchant_contact: string
  order_info: string
  pending_status: string
  received_status: string
  refund_pending: string
  refunded: string
  refunded_status: string
  reject_reason: string
  rejected_status: string
  resolved_status: string
  return_address: string
  return_details: string
  return_method: string
  return_solution: string
  search_carrier: string
  shipping_carrier: string
  shop_now: string
  tracking_number: string
  wait_for_review: string
  customer_address: string
  [property: string]: any
}
